import { render, staticRenderFns } from "./shareProfit.vue?vue&type=template&id=0fbccbc6&scoped=true&"
import script from "./shareProfit.vue?vue&type=script&lang=js&"
export * from "./shareProfit.vue?vue&type=script&lang=js&"
import style0 from "./shareProfit.vue?vue&type=style&index=0&id=0fbccbc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbccbc6",
  null
  
)

export default component.exports